import React from 'react'
import AppRouting from './components/Navigation'

function App() {
  return (
    <div style={{padding:'2rem'}}>
      <AppRouting />
    </div>
  )
}

export default App
